module.exports = __webpack_public_path__ + "img/BlinkArt_Mace1H_Epic.5138984e.png";